<template>
  <div :style="{ transform: `rotate(${rotation}deg)`, scale, display: 'block' }">
    <svg width="30" height="80" viewBox="0 0 30 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.5 2.26944L29.5 77.7306C29.5 78.1759 29.1594 78.5 28.7838 78.5H1.21622C0.840626 78.5 0.5 78.1759 0.5 77.7306L0.5 2.26944C0.5 1.82409 0.840628 1.5 1.21622 1.5L28.7838 1.5C29.1594 1.5 29.5 1.82409 29.5 2.26944Z"
        fill="#FFEED9"
        stroke="#C96500" />
      <path
        d="M7.5 16V14.3333H9.16667V16H7.5ZM7.5 12.6667V11H9.16667V12.6667H7.5ZM10.8333 16V14.3333H12.5V16H10.8333ZM10.8333 12.6667V11H12.5V12.6667H10.8333ZM14.1667 16V14.3333H15.8333V16H14.1667ZM14.1667 12.6667V11H15.8333V12.6667H14.1667ZM17.5 16V14.3333H19.1667V16H17.5ZM17.5 12.6667V11H19.1667V12.6667H17.5ZM20.8333 16V14.3333H22.5V16H20.8333ZM20.8333 12.6667V11H22.5V12.6667H20.8333Z"
        fill="#C96500" />
      <path
        d="M25.5 24.5C25.7761 24.5 26 24.7239 26 25C26 25.2761 25.7761 25.5 25.5 25.5H4.5C4.22386 25.5 4 25.2761 4 25C4 24.7239 4.22386 24.5 4.5 24.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 29.5C25.7761 29.5 26 29.7239 26 30C26 30.2761 25.7761 30.5 25.5 30.5H4.5C4.22386 30.5 4 30.2761 4 30C4 29.7239 4.22386 29.5 4.5 29.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 34.5C25.7761 34.5 26 34.7239 26 35C26 35.2761 25.7761 35.5 25.5 35.5H4.5C4.22386 35.5 4 35.2761 4 35C4 34.7239 4.22386 34.5 4.5 34.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 39.5C25.7761 39.5 26 39.7239 26 40C26 40.2761 25.7761 40.5 25.5 40.5H4.5C4.22386 40.5 4 40.2761 4 40C4 39.7239 4.22386 39.5 4.5 39.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 44.5C25.7761 44.5 26 44.7239 26 45C26 45.2761 25.7761 45.5 25.5 45.5H4.5C4.22386 45.5 4 45.2761 4 45C4 44.7239 4.22386 44.5 4.5 44.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 49.5C25.7761 49.5 26 49.7239 26 50C26 50.2761 25.7761 50.5 25.5 50.5H4.5C4.22386 50.5 4 50.2761 4 50C4 49.7239 4.22386 49.5 4.5 49.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 54.5C25.7761 54.5 26 54.7239 26 55C26 55.2761 25.7761 55.5 25.5 55.5H4.5C4.22386 55.5 4 55.2761 4 55C4 54.7239 4.22386 54.5 4.5 54.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 59.5C25.7761 59.5 26 59.7239 26 60C26 60.2761 25.7761 60.5 25.5 60.5H4.5C4.22386 60.5 4 60.2761 4 60C4 59.7239 4.22386 59.5 4.5 59.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 64.5C25.7761 64.5 26 64.7239 26 65C26 65.2761 25.7761 65.5 25.5 65.5H4.5C4.22386 65.5 4 65.2761 4 65C4 64.7239 4.22386 64.5 4.5 64.5H25.5Z"
        fill="#C96500" />
      <path
        d="M25.5 69.5C25.7761 69.5 26 69.7239 26 70C26 70.2761 25.7761 70.5 25.5 70.5H4.5C4.22386 70.5 4 70.2761 4 70C4 69.7239 4.22386 69.5 4.5 69.5H25.5Z"
        fill="#C96500" />
    </svg>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SvgAssetContainer',
  props: {
    rotation: {
      type: Number,
      default: 0 // Rotation degree (0, 90, 180, 270)
    },
    scale: {
      type: Number,
      default: 1
    }
  }
});
</script>
